import React, { useEffect, useState } from 'react'
import ParametrosApi from 'services/robinhood/ParametrosApi';

export default function Header(props) {
    const [logo_exibir, setLogo_exibir] = useState(localStorage.getItem('parametros_logo_exibir') ? JSON.parse(localStorage.getItem('parametros_logo_exibir')).parametros_logo_exibir : 0);
    const [logo_cinza, setLogo_cinza] = useState(localStorage.getItem('parametros_logo_cinza') ? JSON.parse(localStorage.getItem('parametros_logo_cinza')).parametros_logo_cinza : 1);

    const LogoImg = (props) => {
        return props.logo_cinza == 1
            ? <img src="\assets\images\fjp_header_gray.svg"></img>
            : <img src="\assets\images\fjp_header.svg"></img>
    }

    return (
        <>
            <section className='content' style={{ marginBottom: '' }}>
                <div className='block-header'>
                    <div className='row'>
                        <div className='col-lg-7 col-md-6 col-sm-12'>
                            <h2 className="text-muted" style={{}}>
                                {logo_exibir == 1
                                    ? < LogoImg logo_cinza={logo_cinza} />
                                    : <img src="\assets\images\fjp_header_empty.svg"></img>
                                }
                                <span style={{ position: 'absolute', top: '-4px', marginLeft: logo_exibir == 1 ? '20px' : '-10px' }}> PORTAL ROBIN HOOD </span>  </h2>
                            <small style={{ marginLeft: logo_exibir == 1 ? '128px' : '0px', top: '20px', position: 'absolute' }} className='text-muted'> DADOS CONSOLIDADOS PELA FUNDAÇÃO JOÃO PINHEIRO  </small>
                        </div>
                    </div>
                </div>
                {props.children}
            </section>
        </>
    )
}